import React, { useEffect } from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import {
  AccountCircle,
  TransferWithinAStation,
  LocationOn,
} from '@mui/icons-material';

import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import '../../styles/App.scss';
import { VIEW_SERVICE_LIST_FROM } from '../../component/common/Routes/AppRoutes';
import CustomButton from '../../component/ui/FormFields/Button';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import {
  resetServiceDetails,
  serviceAddRequest,
} from '../../redux/Service/ServiceAction';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
export default function AddService() {
  const {
    handleSubmit,
    control,
    setError,
    watch,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetServiceDetails());
  }, []);
  const serviceDetail = useSelector((state) => state.services?.Service || {});
  const successMessage = serviceDetail?.success;
  const errorMessage = serviceDetail?.error;
  const loading = serviceDetail?.loading;

  useEffect(() => {
    if (errorMessage) {
      setError('services', { type: 'manual', message: errorMessage });
      dispatch(resetServiceDetails());
    }
  }, [errorMessage]);

  useEffect(() => {
    if (successMessage != ' ') {
      toast.success('Service Inserted Successfully', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          navigate(VIEW_SERVICE_LIST_FROM); // Navigate after the toast is closed
        },
      });

      dispatch(resetServiceDetails());
    }
  }, [successMessage]);
  const serviceTypeValue = watch('arrival_departure_type');
  const isTransit = serviceTypeValue?.value === '3';
  const options = {
    serviceType: [
      { value: '1', label: 'Arrival' },
      { value: '2', label: 'Departure' },
      { value: '3', label: 'Transit' },
    ],
    airports: [
      { value: 'chennai', label: 'Chennai' },
      { value: 'pune', label: 'Pune' },
      { value: 'kolkata', label: 'Kolkata' },
    ],
    typeOfAirport: [
      { value: '1', label: 'Domestic' },
      { value: '2', label: 'International' },
      { value: '3', label: 'Both' },
    ],

    transitServiceType: [
      { value: '0', label: 'International To Domestic' },
      { value: '1', label: 'Domestic To International' },
      { value: '2', label: 'Domestic To Domestic' },
      { value: '3', label: 'International To International' },
    ],
  };

  const formFields = [
    {
      name: 'services',
      label: 'Service',
      placeholder: 'Enter Service ',
      type: 'text',
      icon: <AccountCircle />,
      rules: { required: 'Service  is required' },
    },

    {
      name: 'arrival_departure_type',
      label: 'Arrival Departure Type',
      placeholder: 'Select Type',
      type: 'autocomplete',
      options: options.serviceType,

      icon: <TransferWithinAStation />,
      rules: { required: 'Select Service Type' },
    },
    // {
    //   name: "arrival",
    //   label: "Arrival",
    //   placeholder: "Enter Arrival Description",
    //   type: "text",
    //   icon: <FlightLand />,
    //   multiline: true
    //   // rules: { required: "Arrival description is required" },
    // },
    // {
    //   name: "departure",
    //   label: "Departure",
    //   placeholder: "Enter Departure Description",
    //   type: "text",
    //   icon: <FlightTakeoff />,
    //   multiline: true
    //   // rules: { required: "Departure description is required" },
    // },
    // {
    //   name: "transit",
    //   label: "Transit",
    //   placeholder: "Enter Transit Description",
    //   type: "text",
    //   icon: <TransferWithinAStation />,
    //   multiline: true,
    //   //  rules: { required: "Transit description is required" },
    // },
    {
      name: 'service_type',
      label: 'Service Type',
      placeholder: 'Select Service Type',
      type: 'autocomplete',
      options: options.typeOfAirport,
      icon: <LocationOn />,
      rules: { required: 'Select Airport Type' },
      sm: 12,
    },
    // {
    //   // name: "price",
    //   // label: "Price",
    //   // placeholder: "Enter Price",
    //   // type: "text",
    //   // icon: <MonetizationOn />,
    //   // rules: { required: "Price is required" },
    // },
    ...(isTransit
      ? [
          {
            name: 'transit_type',
            label: 'Transit Service Type',
            placeholder: 'Select Transit Service Type',
            type: 'autocomplete',
            options: options.transitServiceType,
            icon: <TransferWithinAStation />,
            rules: { required: 'Transit Service Type is required' },
            sm: 12,
          },
        ]
      : []),
  ];
  return (
    <>
      <ToastContainer />
      <Box component={Paper} sx={{ margin: '30px', padding: '30px' }}>
        <Typography variant='h5' className='form-heading'>
          Add Service
        </Typography>
        <Box className='add_service_form_heading'>
          <form
            onSubmit={handleSubmit(async (data) => {
              try {
                await dispatch(
                  serviceAddRequest({
                    ...data,
                    service_type: data.service_type?.value || data.service_type,
                    arrival_departure_type:
                      data.arrival_departure_type?.value || data.airport_type,
                    transit_type: data.transit_type?.value,
                    price: data.price?.toString() || null,
                    transit: null,
                    arrival: null,
                    departure: null,
                  })
                );
              } catch (error) {
                console.error('Error submitting staff data:', error);
              }
            })}
          >
            <Grid container spacing={2}>
              {formFields.map((field) => (
                <Grid
                  item
                  xs={12}
                  sm={
                    field.sm ||
                    (['Arrival', 'Departure', 'Transit'].includes(field.label)
                      ? 12
                      : 6)
                  }
                  key={field.name}
                >
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    label={field.label}
                    placeholder={field.placeholder}
                    startAdornment={field.icon}
                    rules={field.rules}
                    options={field.options}
                    error={!!errors[field.name]}
                    multiline={field.multiline}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Box className='button-container'>
                  <CustomButton
                    variant='contained'
                    className='cancel-button'
                    type='button'
                    text={'back'}
                    link={VIEW_SERVICE_LIST_FROM}
                  />
                  <CustomButton
                    variant='contained'
                    className='success-button'
                    type='submit'
                    loading={loading}
                    text={'submit'}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </>
  );
}
